/**
 * Trabeate's official accounts, as they appear in the footer.
 *
 * Set in type rather than brand glyphs — no platform marks were available at design time.
 * Swapping in SVGs later means adding an icon to each entry here and nothing else.
 */

export interface SocialLink {
  /** Shown as typed. Uppercase by design, not by `text-transform`. */
  readonly label: string;
  readonly href: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  { label: 'X', href: 'https://x.com/trabeatehq' },
  { label: 'INSTAGRAM', href: 'https://instagram.com/trabeatehq' },
  { label: 'THREADS', href: 'https://www.threads.com/@trabeatehq' },
];

/**
 * Reddit, held back deliberately — not forgotten.
 *
 * The account that exists is a *user profile* (`/user/TrabeateHQ`), which reads as an
 * individual rather than a company presence; the convention when companies do surface Reddit
 * is to link a subreddit. Real-estate investing has a large, active Reddit population, so this
 * is worth doing properly rather than early. Add the entry to SOCIAL_LINKS once r/trabeate
 * exists.
 */
export const REDDIT_PROFILE_URL = 'https://www.reddit.com/user/TrabeateHQ/';

/**
 * Applied to every outbound social link.
 *
 * `noopener` denies the destination page a `window.opener` reference back to this one;
 * `noreferrer` withholds the referrer. Modern browsers imply `noopener` for `target="_blank"`,
 * but stating it keeps the guarantee independent of the browser (REQ-LANDING-005).
 */
export const EXTERNAL_LINK_REL = 'noopener noreferrer';
